export default (state, action) => {
  const modeString = action.payload;

  return {
    ...state,
    mode: modeString,
  };
};
